import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable canonical/filename-match-regex */
import { createContext, useContext, useMemo } from 'react';
import { getDayjs } from '@hivebrite/utils';
export const DayjsContext = createContext({
    dayjs: () => {
        throw new Error('DayjsContext must be used within a DayjsProvider');
    },
    locale: '',
});
export const useDayjsContext = () => useContext(DayjsContext);
export const DayjsProvider = ({ children, locale, }) => {
    const contextValue = useMemo(() => {
        const dayjs = getDayjs({ language: locale });
        return { dayjs, locale };
    }, [locale]);
    return (_jsx(DayjsContext.Provider, { value: contextValue, children: children }));
};
//# sourceMappingURL=DayjsContext.js.map